import { providesList } from '@helpers/index';
import BaseService from '../base';
import {
  AreaSectionApiProps,
  AreaSectionFilterProps,
  EmployersApiProps,
  FacilitiesApiProps,
  SectionsApiProps,
} from './types';

class Site extends BaseService {
  getEmployers() {
    return {
      query: (siteId: number) => `${this.url}/${siteId}/employers`,
      providesTags: (result: EmployersApiProps | undefined) => providesList(result, this.tagType),
    };
  }

  getFacilities() {
    return {
      query: (siteId: number) => `${this.url}/${siteId}/facilities`,
      providesTags: (result: FacilitiesApiProps | undefined) => providesList(result, this.tagType),
    };
  }

  getDumpAreaSectionsBySite() {
    return {
      query: (siteId: number) => `${this.url}/${siteId}/area-sections?category=area&dump=true`,
      providesTags: (result?: SectionsApiProps) => providesList(result, this.tagType),
    };
  }

  getAreaSectionsBySite() {
    return {
      query: ({ siteId, ...params }: AreaSectionFilterProps) => ({
        url: `${this.url}/${siteId}/sections?category=area`,
        params,
      }),
      // eslint-disable-next-line max-len
      providesTags: (result: AreaSectionApiProps | undefined) => providesList(result?.sections, this.tagType),
    };
  }
}

export default new Site('sites', 'Site');
